import React, { Fragment } from 'react';
import clsx from 'clsx';
import styled from 'styled-components';
import SelectSearch from 'react-select-search';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from "react-router-redux";
import { signUpRequest, getSchoolFormationRequest, getSessionRequest } from '../../../../../../../../services/api.service';
import * as FbService from '../../../../../../../../services/fb.service';
import { LocalStorage } from '../../../../../../../../services/localstorage.service';
import { updateSession } from '../../../../../../../../reducers';
import Box from '../../../../../../../../components/box';
import { emailRegexp, phoneRegexp } from '../../../../../../../reviews';
import { InputBlock } from '../../../../../../../reviews/components/InfoBox';
import { SCHOOL_TYPES } from '../../../../../../../sign-up/SignUpTutor';
import { ROUTES } from '../../../../../../../';

const FbErrorStyled = styled(Box)`
  font-size: 18px;
  font-weight: 600;
`;

const FormStyled = styled(Box)`
  max-width: 100%;
  width: 351px;
  box-shadow: 0px 2px 5.8px 0.2px rgba(83, 63, 65, 0.54);
  border: solid 2.5px #eeeeee;
  background-color: #ffffff;
  margin: auto;
  padding: 45px;

  @media (max-width: 425px) {
    padding: 15px;
  }
`;

// const FormFieldStyled = styled(Box).attrs({component: 'input', autoComplete: 'new-password'})`
//   height: 44px;
//   width: 100%;
//   padding: 0 16px;
//   margin-bottom: 20px;
//   background-color: #f1f1f1;
//   font-size: 21.5px;
//   line-height: 2.23;
//   letter-spacing: 1.08px;
//   border: none;
//   border-radius: 5px;

//   &:last-child {
//     margin-bottom: 0;
//   }

//   &::placeholder {
//     color: #797979;
//   }
// `;

const FormBtnStyled = styled(Box).attrs({ component: 'button' })`
  width: 100%;
  height: 54px;
  border-radius: 27px;
  background-color: #AF1318;
  font-size: 16px;
  font-weight: 900;
  line-height: 3;
  letter-spacing: 0.8px;
  text-align: center;
  color: #ffffff;
  outline: none;
`;

const FormFbBtnStyled = styled(Box).attrs({ component: 'button' })`
  width: 100%;
  min-width: 230px;
  height: 46px;
  border-radius: 22.4px;
  background-color: #3a5794;

  font-size: 16px;
  font-weight: 900;
  line-height: 2.03;
  letter-spacing: 0.16px;
  text-align: center;
  color: #ffffff;
  outline: none;

  > *:first-child {
    width: 12px;
    height: 26px;
    margin-left: 17px;
  }
`;

const SelectSearchStyled = styled(SelectSearch)`
  position: relative;

  &--focus > div { display: block !important; }

  &__search {
    display: block;
    width: 100%;
    height: 41px;
    padding: 0 14px;
    background: #f1f1f1;
    border-radius: 4px;
    border: 1px solid transparent;
    font-size: 20px;
    font-weight: normal;
    letter-spacing: 1px;
    font-weight: 700;
    color: #3b3939;
    transition: border-color .3s, box-shadow .3s;
    text-align: left;

    &:-webkit-autofill { -webkit-text-fill-color: inherit; -webkit-box-shadow: 0 0 0 1000px #f1f1f1 inset; box-shadow: 0 0 0 1000px #f1f1f1 inset; border-color: #f1f1f1; }
    &:focus { border-color: #4db1e0; box-shadow: 0px 0px 11px 0px rgba(77,177,224,0.58); }
    &::placeholder { font-size: 20px; font-weight: normal; color: #797979; text-align: left; }
  }

  > div {
    display: none;
    position: absolute;
    top: 40px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 4px;
    overflow: auto;
    -webkit-box-shadow: 0 7px 14px 0 rgba(50, 50, 93, 0.1), 0 3px 6px 0 rgba(0, 0, 0, 0.07);
    box-shadow: 0 7px 14px 0 rgba(50, 50, 93, 0.1), 0 3px 6px 0 rgba(0, 0, 0, 0.07);
    z-index: 100;
    min-height: 49px;

    li {
      font-size: 16px;
      font-weight: 400;
      color: #616b74;
      padding: 5px 15px;
      border-top: 1px solid #eee;
      cursor: pointer;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }
  }
`;

const FormGroupStyled = styled.div`
  &.error ${SelectSearchStyled},
  &.required ${SelectSearchStyled} {
    input[type="search"] {
      border: 1px solid #4db1e0;
      box-shadow: 0px 0px 11px 0px rgba(77,177,224,0.58);
    }
  }
`;

const SelectBlockStyled = styled(InputBlock).attrs({ component: 'select' })`
  text-indent: 5px;

  ${props => !props.field.value ? `
    font-size: 20px !important;
    font-weight: normal !important;
    color: #797979 !important;
    text-align: left !important;
  ` : ''}
`;

function FormFbBtn({ children, ...rest }) {
  return (
    <FormFbBtnStyled flex alignItemsCenter {...rest}>
      <Box component="img" flexShrink={0} src={`${process.env.NEXT_PUBLIC_PUBLIC_URL}/img/cours/private/Logo-facebook.png`}/>
      <Box flexGrow={1}>{children}</Box>
    </FormFbBtnStyled>
  );
}

function SelectBlock(props) {
  return (
    <SelectBlockStyled {...props} />
  );
}

function SchoolBlock({ field, submitted, changeFormData, schools, ...rest }) {
  const hasRequiredError = submitted && field.required && !field.value &&
    field.error;
  const hasError = submitted && !hasRequiredError && field.error;
  const valid = !hasRequiredError && !hasError;

  return (
    <FormGroupStyled
      className={clsx('field-group',
        { required: hasRequiredError, error: hasError, valid })}
    >
      <SelectSearchStyled
        name={field.name}
        value={field.value || ''}
        onChange={({ value }) => changeFormData({ [field.name]: value })}
        options={schools.map(({ key, name }) => ({ value: key, name }))}
        placeholder={field.placeholder}
        {...rest}
      />
    </FormGroupStyled>
  );
}

class Form extends React.Component {
  state = {
    fields: {
      name: {
        name: 'name',
        value: '',
        placeholder: 'Ton prénom',
        required: true,
        error: false
      },
      email: {
        name: 'email',
        value: '',
        placeholder: 'E-mail',
        required: true,
        regexp: emailRegexp,
        error: false
      },
      phone: {
        name: 'phone',
        value: '',
        placeholder: 'Téléphone',
        required: true,
        regexp: phoneRegexp,
        error: false
      },
      password: {
        name: 'password',
        value: '',
        placeholder: 'Mot de passe',
        required: true,
        error: false
      },
      schoolType: {
        name: 'schoolType',
        value: '',
        placeholder: 'Type d\'école',
        required: true,
        error: false
      },
      school: {
        name: 'school',
        value: '',
        placeholder: 'Choix d\'une école',
        required: true,
        error: false
      }
    },
    submitted: false,
    schools: [],
    facebookId: null,
    facebookError: null
  };

  componentDidMount() {
    this.initFacebook();
  }

  initFacebook = () => {
    // Set Handlers
    FbService.setLoginHandler(params => {
      LocalStorage.setItem('auth_token', params.response.auth_token);
      this.updateSession();
    });

    FbService.setRegistrationHandler(params => {
      if (!this.state.submitted) { this.setState(() => ({ submitted: true })); }

      this.setState(() => ({ facebookId: params.fb_user_fields_data.id }));

      this.changeFormData({
        email: params.fb_user_fields_data.email,
        name: params.fb_user_fields_data.first_name,
        password: ''
      });
    });

    FbService.setErrorHandler(
      params => this.setState({ facebookError: params.msg }));
  };

  changeFormData = changes =>
    this.setState(
      ({ fields }) => {
        const newFields = { ...fields || {} };

        Object.keys(changes || {}).forEach(propName => {
          const value = changes[propName];
          newFields[propName] = { ...newFields[propName], value };

          if (propName === 'schoolType' && value && value !==
            fields[propName].value) {
            this.updateSchools(value);
            newFields.school = { ...newFields.school, value: '' };
          }
        });

        return { fields: newFields };
      },
      () => this.validateForm()
    );

  validateForm = (successCb = () => { }, errorCb = () => { }) =>
    this.setState(
      ({ fields, facebookId }) => {
        const newFields = { ...(fields || {}) };

        Object.keys(newFields).forEach(fieldName => {
          const field = newFields[fieldName] || {};
          let error = (field.required && !field.value) ||
          (field.regexp && !field.regexp.test(field.value)) ? true : false;

          // Specific password case
          if (fieldName === 'password' && error && facebookId) {
            error = false;
          }

          newFields[fieldName] = { ...field, error };
        });

        return { fields: newFields };
      },
      () => {
        const fields = this.state.fields;

        if (Object.keys(fields).some(fieldName => fields[fieldName].error)) {
          errorCb(fields);
        }
        else {
          successCb(fields);
        }
      });

  submitFormHandler = ev => {
    ev.preventDefault();

    if (!this.state.submitted) { this.setState(() => ({ submitted: true })); }

    this.validateForm(fields => {
      const { email, name, phone, password, schoolType, school } = fields || {};

      signUpRequest({
        typeStudent: 'tutor',
        email: email.value,
        firstName: name.value,
        phoneNumber: phone.value,
        password: password.value,
        formation: schoolType.value,
        selectedSchool: school.value,
        facebook_id: this.state.facebookId
      })
        .then(() => {
          // this.props.showAlert('Bienvenue chez Clevermate !', 'Félicitations');
          this.updateSession();
        })
        .catch(error => {
          if (error.msg) {
            this.props.showAlert(null, error.msg, 'error');
          }
        });
    });
  };

  updateSchools = schoolType => {
    this.setState({ schools: [] });

    getSchoolFormationRequest(schoolType)
      .then(({ schools = [] }) => this.setState({ schools }));
  };

  updateSession = () => {
    this.props.updateSession().then(session => {
      if (session.is_connected) {
        this.props.goTo(ROUTES.TUTOR_ONBOARDING);
      }
    });
  };

  render() {
    const { fields, submitted, schools, facebookId, facebookError } = this.state;
    const hasRequiredError = submitted && Object.keys(fields)
      .some(
        fieldName => fields[fieldName].required && !fields[fieldName].value &&
          fields[fieldName].error);
    const hasError = submitted && Object.keys(fields)
      .some(fieldName => fields[fieldName].error &&
        (!fields[fieldName].required || fields[fieldName].value));

    return (
      <FormStyled
        className={clsx(
          'form form-get-info',
          { error: hasError, required: !hasError && hasRequiredError }
        )}
      >
        <form
          action="?"
          method="post"
          className="js-validate-form"
        >
          <div className="form__shell">
            <div className="form__body">
              {!facebookId && (
                <Fragment>
                  {facebookError
                    ? <FbErrorStyled mb={2} red>{facebookError}</FbErrorStyled>
                    : (
                      <Fragment>
                        <FormFbBtn onClick={() => FbService.startFbConnect()}>S’inscrire avec Facebook</FormFbBtn>

                        <Box my={1} fontSize={14.5} fontWeight={900} textAlign="center">OU</Box>
                      </Fragment>
                    )
                  }
                </Fragment>
              )}

              <div className="form__row">
                <InputBlock
                  field={fields.name}
                  submitted={submitted}
                  changeFormData={this.changeFormData}
                />
              </div>

              <div className="form__row">
                <InputBlock
                  field={fields.email}
                  submitted={submitted}
                  changeFormData={this.changeFormData}
                  readOnly={!!facebookId}
                  disabled={!!facebookId}
                />
              </div>

              <div className="form__row">
                <InputBlock
                  field={fields.phone}
                  submitted={submitted}
                  changeFormData={this.changeFormData}
                />
              </div>

              <div className="form__row">
                <SelectBlock
                  field={fields.schoolType}
                  submitted={submitted}
                  changeFormData={this.changeFormData}
                >
                  <option value="" disabled>{fields.schoolType.placeholder}</option>

                  {SCHOOL_TYPES.map(({ key, title }) => (
                    <option key={key} value={key}>{title}</option>
                  ))}
                </SelectBlock>
              </div>

              {fields.schoolType.value && <div className="form__row">
                <SchoolBlock
                  schools={schools}
                  field={fields.school}
                  submitted={submitted}
                  changeFormData={this.changeFormData}
                />
              </div>}

              {!facebookId && (
                <div className="form__row">
                  <InputBlock
                    field={fields.password}
                    submitted={submitted}
                    changeFormData={this.changeFormData}
                    type="password"
                  />
                </div>
              )}

              {!hasError && hasRequiredError && (
                <div className="form__message fields-required">
                  <p>*Champ(s) obligatoire(s)</p>
                </div>
              )}

              {hasError && (
                <div className="form__message fields-invalid">
                  <p>*Champ(s) invalide(s)</p>
                </div>
              )}
            </div>

            <div className="form__foot">
              <FormBtnStyled onClick={this.submitFormHandler}>COMMENCER</FormBtnStyled>
            </div>
          </div>
        </form>
      </FormStyled>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators({ updateSession }, dispatch),
  goTo: page => {
    dispatch(push(page));
  }
});

export default connect(
  null,
  mapDispatchToProps
)(Form);
